import moment from "moment";

export class UploadMediaReportItem {
  constructor(
    public mediaId: number,
    public filename: string,
    public tenantUniqueId: string,
    public date: moment.Moment,
    public status: string,
    public quality: number,
  ) {}
}

export class SQCCRecord {
  public duration: moment.Duration;
  constructor(
    public id: string,
    public severity: number,
    public startTime: moment.Duration,
    public endTime: moment.Duration,
    public issueType: string,
    public description: string,
    public snapshot: string,
    public approved: boolean,
  ) {
    this.duration = endTime.clone().subtract(startTime);
  }
}
